import { Component, Input } from '@angular/core';

import { DashboardWidgetDefinition } from '../../widget-and-graphs.models';

@Component({
  selector: 'app-dashboard-widget-preview',
  standalone: false,
  templateUrl: './dashboard-widget-preview.html',
  styleUrl: './dashboard-widget-preview.scss',
})
export class DashboardWidgetPreview {
  @Input({ required: true }) definition!: DashboardWidgetDefinition;

  get iconSvg(): string {
    const value = this.definition.inputs['iconSvg'];
    return typeof value === 'string' ? value : '';
  }

  get data(): Record<string, unknown> {
    return this.definition?.dummyData ?? {};
  }

  get value(): string {
    return String(this.data['value'] ?? this.data['title'] ?? 'Dashboard insight');
  }

  get subtext(): string {
    return String(this.data['subtext'] ?? this.definition?.description ?? '');
  }

  get series(): number[] {
    const values = this.data['series'];
    return Array.isArray(values) ? values.map((value) => Number(value) || 0) : [18, 26, 22, 38, 35, 48, 54];
  }

  get chartPoints(): string {
    const values = this.series;
    const maximum = Math.max(1, ...values);
    return values.map((value, index) => {
      const x = values.length === 1 ? 50 : (index / (values.length - 1)) * 100;
      const y = 38 - (value / maximum) * 34;
      return `${x.toFixed(1)},${y.toFixed(1)}`;
    }).join(' ');
  }

  get rows(): Array<Record<string, unknown>> {
    const rows = this.data['rows'];
    return Array.isArray(rows) ? rows.slice(0, 3) as Array<Record<string, unknown>> : [];
  }

  get metrics(): string[] {
    const metrics = this.data['metrics'];
    return Array.isArray(metrics) ? metrics.map(String) : [];
  }

  rowValues(row: Record<string, unknown>): unknown[] {
    return Object.values(row).slice(0, 3);
  }

}
